import DescriptionList from '@/components/global/DescriptionList';

const DescriptionListWrapper = ({ blok }) => {
  const { list_items, foregroundColor, padding, mobilePadding } = blok;

  return (
    <DescriptionList
      items={list_items}
      foregroundColor={foregroundColor}
      padding={padding}
      mobilePadding={mobilePadding}
    />
  );
};

export default DescriptionListWrapper;
